/* ═══════════════════════════════════════════════════════════════
   NiuYu Volume Discount Sync (modelo Bloom · 3-jul-2026)

   POLÍTICA (ver /docs/logica-descuentos.html):
   Los 4 singles se venden como UNIDADES a precio completo. El descuento
   por volumen es REAL (códigos) y por eso el checkout lo muestra en su
   línea de totales ("AHORRO TOTAL"), como Bloom:

     · 2 unidades (cualquier combinación de singles) → AHORRO10 (10%)
     · 3 unidades → AHORRO15 (15%)
     · 4+ unidades → AHORRO20 (20%)
     · <2 → limpia el código de tier

   Los códigos AHORRO-XX están scoped en Shopify a las 4 variantes
   "1 unidad" (min qty 2/3/4), así que aunque alguien los pegue a mano
   no descuentan kits/accesorios. Este sync cuenta EXACTAMENTE esas
   variantes (espejo del entitlement) y mantiene UN solo tier activo.

   Los KITS no cuentan aquí: traen su descuento AUTOMÁTICO de monto fijo
   ("✦ Ahorro kit · X") que Shopify aplica solo. Regalos (_gift) tampoco.
   Reemplaza al viejo BUNDLE-10/15/20 (solo builder) — mismo % pero
   storewide y con la línea de ahorro visible en el checkout.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Variantes "1 unidad" de los 4 singles (Creatina, Mag, Omega, Inositol).
  // DEBE ser espejo del entitlement de AHORRO10/15/20 en Shopify.
  var UNIT_IDS = [48819262193891, 48819261898979, 48819261997283, 48819262095587];

  var CODES = { 2: 'AHORRO10', 3: 'AHORRO15', 4: 'AHORRO20' };
  var TIER_PREFIXES = ['AHORRO1', 'AHORRO2', 'BUNDLE-']; // BUNDLE- legacy: también se retira

  // v3 (4-jul): el regalo YA NO usa código (es producto $0 — regalo-niu-yu),
  // así que aquí solo preservamos los cupones legítimos del cliente al hacer swap.
  function isTierCode(code) {
    var c = (code || '').toUpperCase();
    return TIER_PREFIXES.some(function (p) { return c.indexOf(p) === 0; });
  }

  var inFlight = false;
  var pendingSync = false; // llegó un evento mientras sincronizaba → re-correr al terminar
  var retryTarget = null;  // anti-bucle: reintentos consecutivos sobre el mismo target
  var retryCount = 0;

  // Cuenta unidades de singles (variantes "1 unidad"), excluyendo regalos.
  // Cualquier combinación cuenta: 2 Creatinas = Creatina + Mag = tier 10%.
  function getUnitQty(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var total = 0;
    cart.items.forEach(function (it) {
      // Los regalos son variantes del producto regalo-niu-yu ($0) — jamás
      // coinciden con UNIT_IDS, así que no hay que filtrarlos aquí.
      // Las líneas de SUSCRIPCIÓN traen su propio 10% (selling plan) y NO
      // cuentan para AHORRO10/15/20 — si no, los descuentos se apilarían.
      if (it.selling_plan_allocation) return;
      if (UNIT_IDS.indexOf(it.variant_id) !== -1) total += it.quantity;
    });
    return total;
  }

  function getCurrentTierCode(cart) {
    if (!cart) return null;
    var codes = cart.discount_codes || [];
    for (var j = 0; j < codes.length; j++) {
      var c = codes[j].code || '';
      if (isTierCode(c) && codes[j].applicable !== false) return c.toUpperCase();
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var t = apps[i].title || '';
      if (isTierCode(t)) return t.toUpperCase();
    }
    return null;
  }

  function targetCodeFor(qty) {
    if (qty >= 4) return CODES[4];
    if (qty >= 3) return CODES[3];
    if (qty >= 2) return CODES[2];
    return null;
  }

  function refreshUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false, _internalSync: true, _bundleSync: true } }));
    return Promise.resolve();
  }

  function applyCode(code) {
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=false', { credentials: 'same-origin' })
      .catch(function () {});
  }

  // No hay endpoint AJAX para quitar UN código: {discount:''} borra TODOS.
  // Capturamos los códigos que NO son de tier (cupones del cliente, regalo),
  // borramos todo, y re-aplicamos los preservados + el tier nuevo (si hay).
  function swapTierCode(cart, newTier) {
    var keep = [];
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      var c = codes[i].code || '';
      if (!c) continue;
      if (isTierCode(c)) continue;                    // tier viejo: fuera
      if (codes[i].applicable === false) continue;    // inaplicables: no re-aplicar
      keep.push(c);
    }
    if (newTier) keep.push(newTier);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return keep.reduce(function (p, code) {
          return p.then(function () { return applyCode(code); });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  function sync() {
    if (inFlight) { pendingSync = true; return Promise.resolve(); }
    inFlight = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = getUnitQty(cart);
        var current = getCurrentTierCode(cart);
        var target = targetCodeFor(qty);

        if (current === target) { retryTarget = null; retryCount = 0; return null; } // ya está el correcto
        if (target === null && current === null) { retryTarget = null; retryCount = 0; return null; }

        // Anti-bucle: si el mismo target no pega tras 3 intentos (código
        // deshabilitado en Shopify, etc.), parar hasta que el carrito cambie.
        if (target === retryTarget) {
          if (retryCount >= 3) return null;
          retryCount += 1;
        } else { retryTarget = target; retryCount = 1; }

        // Cambio de tier (subir, bajar o quitar): swap atómico preservando
        // el código del regalo y cualquier cupón legítimo del cliente.
        // Verificación post-swap: el apply vía /discount puede perderse en
        // carreras de arranque (visto 20-jul: el sync de page-load quitó
        // AHORRO10 y AHORRO15 nunca pegó → clienta sin su descuento). El
        // re-sync en ~1.2s detecta current!==target y reintenta.
        return swapTierCode(cart, target)
          .then(refreshUi)
          .then(function () { scheduleSync(1200); });
      })
      .catch(function () {})
      .finally(function () {
        inFlight = false;
        if (pendingSync) { pendingSync = false; scheduleSync(250); }
      });
  }

  var t = null;
  function scheduleSync(ms) {
    if (t) clearTimeout(t);
    t = setTimeout(sync, ms || 300);
  }

  function init() {
    sync();
    // Segunda pasada de arranque: pesca cualquier carrera del init (Minimog,
    // gift-sync y este script arrancan a la vez y el primer sync puede perder).
    setTimeout(sync, 3000);
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function (data) {
        if (data && (data._bundleSync || data._internalSync)) return;
        scheduleSync(300);
      });
    }
    document.addEventListener('cart:refresh', function (e) {
      var d = e.detail || {};
      if (d._bundleSync || d._internalSync) return;
      scheduleSync(400);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
